import {
  CHECKLIST_ITEM_STATE_ACTIVE,
  CHECKLIST_ITEM_STATE_COMPLETE,
  CHECKLIST_ITEM_STATE_INCOMPLETE,
} from '../constants';

/**
 * Determines the visual state of a checklist item based on current progress.
 * @param {number} completedUpTo - The highest checklist order that has been completed
 * @param {number} itemOrder - The order of the checklist item being evaluated
 * @returns {string} The state of the checklist item (complete, active, or incomplete)
 */
// eslint-disable-next-line import/prefer-default-export
export const checklistState = (completedUpTo, itemOrder) => {
  if (completedUpTo >= itemOrder) {
    return CHECKLIST_ITEM_STATE_COMPLETE;
  }

  if (itemOrder === completedUpTo + 1) {
    return CHECKLIST_ITEM_STATE_ACTIVE;
  }

  return CHECKLIST_ITEM_STATE_INCOMPLETE;
};
